<template>
  <div class="tile">
    <div class="text-wrapper">
      <div class="text-box" :class="{'active': current === 1}">
        <p>
          <span class="number">100</span>
          <span class="strong">Ergebnis vor Steuern</span>
          <span class="unit">in Mio. EUR</span>
        </p>
      </div>
      <div class="text-box" :class="{'active': current === 2}">
        <p>
          <span class="number">3,7</span>
          <span class="strong">Umsatzerlöse</span>
          <span class="unit">in Mrd. EUR</span>
        </p>
      </div>
    </div>
    <div class="image-wrapper">
      <div class="image-box" :class="{'active': current === 1}">
        <img src="../assets/images/report/check.png" alt="">
      </div>
      <div class="image-box" :class="{'active': current === 2}">
        <img src="../assets/images/report/arrow.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportTile",
  data() {
    return {
      current: 1
    }
  },
  mounted() {
    setInterval(() => {
      this.current = this.current === 1 ? 2 : 1;
    },5000)
  }
}
</script>

<style scoped>
  .tile {
    position: relative;
    display: block;
    min-width: 480px;
    margin-right: 200px;
    margin-top: 140px;
  }
  .tile:before {
    content: "";
    position: relative;
    display: block;
    padding-top: 100%;
    background-image: url(../assets/images/report/tile.jpg);
    background-size: 100%;
  }
  .text-box {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 11%;
    padding: 7% 8%;
    background-color: #102D61;
    color: #B1D995;
    font-size: 24px;
    line-height: 1.3;
    font-weight: 700;
    opacity: 0;
    pointer-events: none;
    transform: translate3d(0, 0, 0) scale(0.7);
    transition: 0.4s ease 0.35s;
  }
  .text-box.active {
    transform: translate3d(0, 0, 0) scale(1) !important;
    pointer-events: all;
    opacity: 1;
    transition: 0.4s ease 0.6s;
  }
  p {
    margin: 0;
  }
  span {
    display: block;
  }
  .number {
    font-size: 140px;
    line-height: 1.1;
    margin-top: -0.06em;
    margin-left: -0.03em;
  }
  .unit {
    font-weight: 300;
  }
  .image-box {
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    display: flex;
    align-items: flex-end;
    margin-right: -35%;
    transform: translate3d(0, 0, 0) scale(0.7);
    opacity: 0;
    pointer-events: none;
    transform-origin: 0 100%;
    transition: 0.4s ease 0s;
    max-width: 130%;
    justify-content: flex-end;
  }
  .image-box:nth-child(1) {
    transform: translate3d(30%, 0, 0) scale(0.7);
  }
  .image-box:nth-child(2) {
    transform: translate3d(-20%, 0, 0) scale(0.7);
    margin-right: -40%;
  }
  .image-box.active {
    transform: translate3d(0, 0, 0) scale(1);
    pointer-events: all;
    opacity: 1;
    transition: 0.4s ease 0.15s;
  }
  img {
    max-height: 50%;
  }
  @media(min-width: 1000px) and (max-height: 799px) {
    .tile {
      min-width: 60vh;
      margin-top: 10vh;
    }
    .text-box {
      font-size: 3.4vh;
    }
    .number {
      font-size: 15vh;
    }
  }
  @media(max-width: 999px) {
    .tile {
      margin: calc(30px + 3%) 0 calc(70px + 12%);
      max-width: 480px;
    }
  }
  @media(max-width: 567px) {
    .tile {
      width: 100vw;
      min-width: 0;
      max-width: 100vw;
      margin-left: -20px;
      margin-right: -20px;
      margin-bottom: 0;
    }
    .text-box {
      margin: 9%;
      font-size: 6vw;
    }
    .number {
      font-size: 28vw;
      margin-bottom: 0.04em;
    }
    .image-box:nth-child(2) {
      margin-right: 0;
      top: 20%;
    }
  }
</style>